import { styled, TableRow } from "@mui/material";

const StyledTableRow = styled(TableRow)(({ theme, ownerState }: any) => {
  // Base styles
  const styles = {
    // Styling for even rows
    "&:nth-child(even)": {
      backgroundColor: "#f5f7f8",
    },
  };

  // Conditionally add selected styles
  if (ownerState?.selected) {
    // Use a selector to override even row styling when selected
    styles["&.Mui-selected, &.Mui-selected:nth-child(even)"] = {
      backgroundColor: `${theme.palette.grey["200"]} !important`,
      border: `2px solid ${theme.palette.secondary.main}`,
    };
  }

  return styles;
});

function UtfTableRow({ children, selected, ...restProps }) {
  return (
    <StyledTableRow selected={selected} {...restProps}>
      {children}
    </StyledTableRow>
  );
}

export default UtfTableRow;
